import { createReducer } from "@reduxjs/toolkit";
import {
  deleteUserFromBlockListReset,
  deleteUserFromBlockListSuccess,
  getUserBlockList,
  getUserBlockListFailure,
  getUserBlockListSuccess,
} from "./actions";

const initialState = {
  allList: [],
  listById: [],
  totalCount: undefined,
  nextOffset: undefined,
  isLoading: false,
  isSuccessUnblock: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getUserBlockList.type, (state, action) => ({
      ...state,
      isLoading: true,
      ...action.payload,
    }))
    .addCase(getUserBlockListSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      isLoading: false,
    }))
    .addCase(getUserBlockListFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(
      deleteUserFromBlockListSuccess.type,
      (state, { payload: { userId } }) => ({
        ...state,
        isSuccessUnblock: true,
        allList: state.allList.filter((id) => id !== userId),
      }),
    )
    .addCase(deleteUserFromBlockListReset.type, (state) => ({
      ...state,
      isSuccessUnblock: false,
    }));
});
